<body>
  <!-- particles.js container -->
  <div id="particles-js"></div>
  <!-- stats - count particles -->
  <!-- particles.js lib - https://github.com/VincentGarreau/particles.js -->
  <section class="section1 links_content">
    <div class="logo text-center wow fadeInDown">
      <img
        src="{{ onPassiveBaseUrl }}onpassive-sept/images/logo.png"
        alt="logo"
        width="20%"
      />
    </div>
    <div class="bg-cards">
      <img
        src="{{ onPassiveBaseUrl }}onpassive-sept/images/cards.png"
        alt="cards"
        class="img-fluid"
      />
    </div>
    <div class="bg-svg">
      <img
        src="{{ onPassiveBaseUrl }}onpassive-sept/images/cards.png"
        alt="cards"
        width="50%"
      />
    </div>
    <div class="container">
      <div class="row whole-row">
        <div class="col-lg-6 col-md-8 robot-img">
          <div class="robot-1st">
            <img
              src="{{ onPassiveBaseUrl }}onpassive-sept/images/robot.png"
              alt="robot"
              width="90%"
            />
          </div>
          <div class="whole-circle">
            <div class="circle-img">
              <img
                src="{{ onPassiveBaseUrl }}onpassive-sept/images/think1.png"
                alt="think1"
              />
            </div>
            <div class="circle-img-2">
              <img
                src="{{ onPassiveBaseUrl }}onpassive-sept/images/circle2.png"
                alt="circle2"
              />
            </div>
            <div class="circle-img-3">
              <img
                src="{{ onPassiveBaseUrl }}onpassive-sept/images/circle3.png"
                alt="circle3"
              />
            </div>
            <div class="circle-img-4">
              <img
                src="{{ onPassiveBaseUrl }}onpassive-sept/images/circle4.png"
                alt="circle4"
              />
            </div>
          </div>
        </div>
        <div class="col-lg-5 contents-right">
          <h1 class="title">Launching Soon</h1>

          <div class="para">
       
            <p>
              Dreams are what a life is made up of. Presenting a life-changing
              earning platform that will not let any single dream go
              unfulfilled. Powered by the best artificial intelligence
              technology and equipped with only the required tools, this is the
              ultimate automated system that will make your life easy. Over
              576551+ people globally are already in. What are you waiting for?
              Join ONPASSIVE to get a life that you have always dreamt about.
            </p>

            <div class="btn-founder wow fadeIn my-4">
              <a
                href="/registration/user?reg={{ userId }}"
                name="regform"
                target="_blank"
                rel="noopener"
                >Become a Founder Now</a
              >
            </div>
            <div class="my-3">&nbsp;</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</body>
